module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 012.124d970a.jpg";